import React from 'react';
import { useMediaQuery } from '@/hooks/useMediaQuery';

const Footer: React.FC = () => {
  const { isMobile } = useMediaQuery();

  const footerStyle: React.CSSProperties = {
    backgroundColor: 'var(--surface-color)',
    borderTop: '1px solid var(--border-color)',
    padding: isMobile ? '1.5rem 0' : '2rem 0',
    paddingBottom: isMobile
      ? `calc(1.5rem + var(--safe-area-inset-bottom))` // Respect iOS home indicator
      : '2rem',
    marginTop: 'auto',
    textAlign: 'center',
  };

  const footerContentStyle: React.CSSProperties = {
    width: '100%',
    padding: isMobile ? '0 0.5rem' : '0 1.5rem',
  };

  const footerTextStyle: React.CSSProperties = {
    fontSize: '0.875rem',
    color: 'var(--text-secondary)',
    margin: 0,
  };

  const linkStyle: React.CSSProperties = {
    color: 'var(--primary-color)',
    textDecoration: 'none',
    fontWeight: '500',
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer style={footerStyle}>
      <div style={footerContentStyle}>
        <p style={footerTextStyle}>
          © {currentYear}{' '}
          <a href="https://checkademic.com" target="_blank" rel="noopener noreferrer" style={linkStyle}>
            Checkademic
          </a>
          . All rights reserved.
          {!isMobile && (
            <>
              {' · '}
              <a href="/privacy" style={linkStyle}>Privacy</a>
              {' · '}
              <a href="/terms" style={linkStyle}>Terms</a>
            </>
          )}
        </p>
        {isMobile && (
          <p style={{ ...footerTextStyle, marginTop: '0.375rem' }}>
            <a href="/privacy" style={linkStyle}>Privacy</a>
            {' · '}
            <a href="/terms" style={linkStyle}>Terms</a>
          </p>
        )}
      </div>
    </footer>
  );
};

export default Footer;
